import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  pickingExceptionSingleReason: {
    defaultMessage: 'Picking exception: {reason}',
    description: 'Single picking exception reason for an item without reporter',
    id: 'dxFtOu',
  },
  pickingExceptionSingleReasonWithReporter: {
    defaultMessage: 'Picking exception: {reason}. Reporter: {reporterName}',
    description: 'Single picking exception reason for an item with reporter',
    id: 'ebyTk2',
  },
  pickingExceptionMultipleReasons: {
    defaultMessage: 'Picking exceptions: {reasons}',
    description: 'Multiple picking exception reasons for an item without reporter',
    id: 'MXiLUW',
  },
  pickingExceptionMultipleReasonsWithReporter: {
    defaultMessage: 'Picking exceptions: {reasons}. Reporter: {reporterName}',
    description: 'Multiple picking exception reasons for an item with reporter',
    id: 'GxSvWj',
  },
  and: {
    defaultMessage: 'and',
    description: 'Conjunction word used to join the last item in a list',
    id: 'U05yLF',
  },
});
